import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '../components/Button';
import { partnerQuestions } from '../utils/constants';

const TestForm = () => {
  const [answers, setAnswers] = useState(
    Array(partnerQuestions.length).fill(null)
  );
  const [formHasError, setFormHasError] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const allAnswersFilled = () => {
    return answers.every((answer) => answer !== null);
  };

  const handleChange = (index, value) => {
    const updatedAnswers = [...answers];
    updatedAnswers[index] = value;
    setAnswers(updatedAnswers);
    setFormHasError(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (allAnswersFilled()) {
      const patternCounts = { A: 0, B: 0, C: 0, D: 0, E: 0 };

      // Questions 1-5 determine the pattern
      answers.forEach((answer, index) => {
        if (index < 5) {
          const question = partnerQuestions[index];
          const selectedOption = question.options.find(
            (opt) => opt.value === answer
          );
          if (selectedOption && selectedOption.pattern) {
            patternCounts[selectedOption.pattern]++;
          }
        }
      });

      // Find the pattern with the most points
      const winningPattern = Object.keys(patternCounts).reduce((a, b) =>
        patternCounts[a] >= patternCounts[b] ? a : b
      );

      // Qualifiers (Q6-8)
      const qualifiers = {
        feeling: answers[5],
        time: answers[6],
        disposition: answers[7]
      };

      navigate('/results', {
        state: { winningPattern, qualifiers, allAnswers: answers }
      });
      setFormHasError(false);
    } else {
      setFormHasError(true);
      // window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    window.scrollTo({
      top: 0
    });
  }, []);

  return (
    <section id="form">
      <h2 className="mb-6 font-title text-3xl font-semibold">
        {t('home.title')}
      </h2>

      <div className="mt-8">
        <form onSubmit={handleSubmit}>
          {partnerQuestions.map((question, qIndex) => (
            <div key={qIndex} className="mt-8">
              <label className="text-lg font-medium text-gray1">
                {qIndex + 1}. {t(`quiz.questions.q${question.id}`)}
              </label>
              <div className="mb-6 mt-4 flex flex-col gap-2">
                {question.options.map((option) => (
                  <label
                    key={option.value}
                    className="flex items-center gap-2 py-[2px] ps-4"
                  >
                    <input
                      type="radio"
                      name={`question-${qIndex}`}
                      value={option.value}
                      checked={answers[qIndex] === option.value}
                      onChange={(e) => handleChange(qIndex, e.target.value)}
                      className=" size-5 accent-primary"
                    />
                    <span className="font-light text-gray2">
                      {t(`quiz.questions.q${question.id}_opt${option.value}`)}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          ))}

          <div className="mt-10 pb-10">
            {formHasError && (
              <p className="mb-4 font-medium text-primary-alt">
                {t('form.errorMessage')}
              </p>
            )}
            <Button type="submit" className="w-full sm:w-auto">
              {t('form.submitButton')}
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default TestForm;
